import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TaglineHeadingContext = /*#__PURE__*/createContext(undefined);
export const TaglineHeadingProvider = ({
  headingStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    headingStyleOverrides
  }), [headingStyleOverrides]);
  return /*#__PURE__*/_jsx(TaglineHeadingContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `TaglineHeading` component.
 * Note: The context is only available when the `TaglineHeading` component is rendered as an ancestor.
 * @returns TaglineHeadingContext - The context for the `TaglineHeading` component.
 * @returns TaglineHeadingContext.headingStyleOverrides - Style overrides to be applied to the `Heading` component.
 */
export const useTaglineHeadingContext = () => {
  const taglineHeadingContext = useContext(TaglineHeadingContext);
  return taglineHeadingContext;
};